<template lang="pug">
.task-item(@click="handleClick")
  .task-left
    .left
      .icon-new-block
        SafeImg(class-name="left-logo" :src="item.taskImgUrl")
    .mid
      .title {{ item.title }}
      .progress
        .progress-right(v-if="item.amount")
          img.progress-right-img(:src="coinIcon")
          .progress-right-text +{{ item.amount }}
        .progress-left
          span(v-if="countdownText && !isInTimeIdle") 再过
          span.countdown-text(v-if="countdownText && !isInTimeIdle") {{ countdownText }}
          span {{ subTitleDesc }}
  .right
    .btn-wrap
      .btn-mark(v-if="item.taskButtonMark") {{ item.taskButtonMark }}
      .btn {{ item.buttonName }}
</template>

<script>
import SafeImg from '@/components/safe-img';
import countdownMixin from '../../common/countdown-mixin';

export default {
  name: 'SubsidyTask',
  components: { SafeImg },
  mixins: [countdownMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    coinIcon() {
      return 'https://m.hellobike.com/fd018348_new_coin.png';
    },
    isInTime() {
      const { startTime, endTime } = this.item;
      if (!startTime || !endTime) return true;
      const now = this.getNowTimeStr();
      return now >= startTime && now <= endTime;
    },
    // 当前时段已完成
    isPeriodDone() {
      return this.isInTime && this.item.taskStatus === 'FINISHED';
    },
    // mixin 需要的：剩余秒数
    countdownSeconds() {
      const { isTomorrow, startTime, nextStartTime } = this.item;
      if (isTomorrow) return 0;
      // 当前时段已完成，倒计时到下一个时段
      if (this.isPeriodDone && nextStartTime) {
        const parts = nextStartTime.split(':').map(Number);
        const [h, m] = parts;
        const s = parts[2] || 0;
        const now = new Date();
        const target = new Date(now);
        target.setHours(h, m, s, 0);
        return Math.max(0, Math.floor((target - now) / 1000));
      }
      if (this.isInTime || !startTime) return 0;
      const [h, m, s] = startTime.split(':').map(Number);
      const now = new Date();
      const target = new Date(now);
      target.setHours(h, m, s, 0);
      return Math.max(0, Math.floor((target - now) / 1000));
    },
    // 当前在时段内且未完成（正常展示 additionalDesc，无倒计时）
    isInTimeIdle() {
      return this.isInTime && !this.isPeriodDone;
    },
    subTitleDesc() {
      const { isTomorrow, nextStartTime, additionalDesc } = this.item;
      if (isTomorrow && nextStartTime) {
        return `明日${nextStartTime}${additionalDesc || ''}`;
      }
      return additionalDesc || '';
    },
  },
  methods: {
    countdownEndEvent() {
      this.$emit('countdown-end');
    },
    handleClick() {
      this.$emit('click', this.item);
    },
    getNowTimeStr() {
      const now = new Date();
      return `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
    },
  },
};
</script>

<style lang="less" scoped>
.task-item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  position: relative;
  padding: 0.12rem;

  &:not(:last-of-type)::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0.51rem;
    right: 0.12rem;
    height: 0.01rem;
    background-color: #f6f6f6;
    transform: scaleY(0.5);
  }

  .task-left {
    display: flex;
    flex: 1;
    min-width: 0;

    .left {
      margin-right: 0.1rem;

      .icon-new-block {
        overflow: hidden;
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 0.12rem;
      }
    }

    .mid {
      display: flex;
      flex-direction: column;
      flex: 1;
      max-width: 1.9rem;
      overflow: hidden;

      .title {
        font-size: 0.14rem;
        line-height: 0.2rem;
        font-weight: 500;
        color: #242729;
        margin-bottom: 0.02rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .progress {
        display: flex;
        align-items: center;

        .progress-left {
          flex: 1;
          min-width: 0;
          color: rgba(90, 96, 102, 0.8);
          font-size: 0.12rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          .countdown-text {
            color: #f4b339;
          }
        }

        .progress-right {
          display: flex;
          align-items: center;
          height: 0.16rem;
          padding-right: 0.08rem;
        }

        .progress-right-img {
          width: 0.16rem;
          height: 0.16rem;
        }

        .progress-right-text {
          color: #fe852a;
          font-weight: 600;
          font-size: 0.12rem;
          margin-left: 0.02rem;
        }
      }
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    flex-shrink: 0;

    .btn-wrap {
      position: relative;
    }

    .btn-mark {
      position: absolute;
      top: -0.06rem;
      right: -0.01rem;
      background: rgba(255, 92, 10, 1);
      color: #fff;
      font-size: 0.08rem;
      line-height: normal;
      padding: 0.02rem 0.04rem;
      border-radius: 0.88rem;
      border-bottom-left-radius: 0;
      white-space: nowrap;
      z-index: 1;
    }

    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 0.62rem;
      height: 0.28rem;
      font-size: 0.12rem;
      font-weight: 500;
      border-radius: 0.32rem;
      background: rgba(255, 232, 136, 1);
      color: #000;
    }
  }
}
</style>
